const Error404= () => <h1>404 page not found</h1>;

export default Error404;